export const HEX_PLAYBACK_INTERVAL_MS = 850;

export function sliderIndexForPointerPosition(clientX, { left, width }, maximumIndex) {
  if (!Number.isFinite(width) || width <= 0) return 0;
  const percent = Math.max(0, Math.min(1, (clientX - left) / width));
  return Math.round(percent * maximumIndex);
}

export function closestRangeHandle(index, { startIndex, selectedIndex }) {
  return Math.abs(index - startIndex) <= Math.abs(index - selectedIndex) ? "start" : "selected";
}

export function createHexTimeController({
  timeline,
  onChange = () => {},
  setIntervalFn = globalThis.setInterval,
  clearIntervalFn = globalThis.clearInterval,
}) {
  const { days } = timeline;
  if (!Array.isArray(days) || days.length === 0) throw new TypeError("A non-empty hex timeline is required.");

  let selectedIndex = days.length - 1;
  let startIndex = 0;
  let timerId = null;

  const notify = (reason) => onChange(controller.state, reason);
  const stop = () => {
    if (timerId === null) return false;
    clearIntervalFn(timerId);
    timerId = null;
    return true;
  };
  const controller = {
    get state() {
      return Object.freeze({
        selectedDate: days[selectedIndex],
        selectedIndex,
        startDate: days[startIndex],
        startIndex,
        isPlaying: timerId !== null,
      });
    },
    selectIndex(index) {
      const nextIndex = Math.max(startIndex, clampIndex(index, days.length));
      if (nextIndex === selectedIndex) return false;
      selectedIndex = nextIndex;
      notify("selected-date");
      return true;
    },
    selectStartIndex(index) {
      const nextStartIndex = Math.min(selectedIndex, clampIndex(index, days.length));
      if (nextStartIndex === startIndex) return false;
      startIndex = nextStartIndex;
      notify("start-date");
      return true;
    },
    previous() {
      return controller.selectIndex(selectedIndex - 1);
    },
    next() {
      if (selectedIndex >= days.length - 1) return false;
      selectedIndex += 1;
      if (selectedIndex === days.length - 1) stop();
      notify("selected-date");
      return true;
    },
    playPause() {
      if (stop()) {
        notify("playback");
        return false;
      }
      let selectedDateChanged = false;
      if (selectedIndex >= days.length - 1) {
        selectedDateChanged = selectedIndex !== startIndex;
        selectedIndex = startIndex;
      }
      if (selectedIndex >= days.length - 1) {
        notify(selectedDateChanged ? "selected-date" : "playback");
        return false;
      }
      timerId = setIntervalFn(() => controller.next(), HEX_PLAYBACK_INTERVAL_MS);
      notify(selectedDateChanged ? "selected-date" : "playback");
      return true;
    },
    destroy() {
      stop();
    },
  };
  return controller;
}

function clampIndex(index, length) {
  const numericIndex = Number.parseInt(index, 10);
  if (!Number.isFinite(numericIndex)) return 0;
  return Math.max(0, Math.min(length - 1, numericIndex));
}
